import { render } from "./LogOut.vue?vue&type=template&id=8c66ba28&scoped=true&ts=true"
import script from "./LogOut.vue?vue&type=script&lang=ts"
export * from "./LogOut.vue?vue&type=script&lang=ts"

import "./LogOut.vue?vue&type=style&index=0&id=8c66ba28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c66ba28"]])

export default __exports__